import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';

import { ReactComponent as Brightness } from '../../assets/icons/brightness.svg';
import { ReactComponent as Darkness } from '../../assets/icons/darkness.svg';
import { ReactComponent as Desktop } from '../../assets/icons/desktop.svg';
// import { ReactComponent as Downarrow } from '../../assets/icons/down-arrow.svg';
import { ReactComponent as Notification } from '../../assets/icons/notification.svg';
import { ReactComponent as TrendUp } from '../../assets/icons/trend-up.svg';
import profile from '../../assets/images/profiles/profile.jpg';
// import { brandImage } from '../../config/branding';
// import LanguageSelector from '../../contexts/language-selector/LanguageSelector';
// import { CustomDashboard } from '../../interface/dashboard.interface';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setSelectedDashboardId } from '../../redux/slices/CustomDashboardSlice';
// import { updateChargerType } from '../../redux/slices/ChargerTypeSlice';
// import ToggleWithIcons from '../toggle-with-icons/ToggleWithIcons';
import TabToggle from '../tab-toggle/TabToggle';

/**
 * Header function component
 */
function Header() {
  const { t, i18n } = useTranslation('sharedComponent');
  const dashboard = window.location.pathname.includes('ev-admin/dashboard');
  const notification: boolean = false;
  // const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { dashboards, defaultDashboard, selectedDashboardId } = useAppSelector(
    (state) => state.customDashboard,
  );
  const reference = useRef<HTMLDivElement>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownNotification, setDropdownNotification] = useState(false);
  // const [chartToggle, setChartToggle] = useState([
  //   {
  //     label: 'personal',
  //     key: 'personal',
  //     isActive: true,
  //   },
  //   {
  //     label: 'commercial',
  //     key: 'commercial',
  //     isActive: false,
  //   },
  // ]);

  const { title, count, icon } = useAppSelector((state: any) => state.pageTitle);

  /**
   * My profile function
   */
  const myProfile = () => setDropdownOpen(false);
  /**
   * Drop down function
   */
  // const dropdown = () => setDropdownOpen(true);




  /**
   * Light and Darkness function
   */
  const lightDarkness = (data: string) => {
    console.log(data);
    setDropdownOpen(false);
  };

  const headerList1 = [
    {
      icon: Brightness,
      active: true,
      key: 'light',
      function: lightDarkness,
      allow: false,
    },
    {
      icon: Darkness,
      active: false,
      key: 'dark',
      function: lightDarkness,
      allow: false,
    },
    {
      icon: Desktop,
      active: false,
      key: 'desk',
      function: lightDarkness,
      allow: false,
    },
  ];
  const headerList2 = [
    {
      label: t('myProfile'),
      addClass: '',
      function: myProfile,
      allow: false,
    },
    // {
    //   label: t('feeConfiguration'),
    //   addClass: '',
    //   function: routeFeeConfiguration,
    //   allow: true,
    // },
    // {
    //   label: t('logout'),
    //   addClass: 'text-danger',
    //   function: logout,
    //   allow: true,
    // },
  ];

  /**
   * Handle the close th drop down function
   * @param event
   */
  const handleClickOutside = (event: MouseEvent) => {
    if (reference.current && !reference.current.contains(event.target as Node)) {
      setDropdownOpen(false);
      setDropdownNotification(false);
    }
  };

  /**
   * Function to switch the tab
   * @param key
   */
  // const handleClickToggle = (key: string) => {
  //   setChartToggle((previousTab) =>
  //     previousTab.map((tab) => ({ ...tab, isActive: tab.key === key })),
  //   );
  //   dispatch(updateChargerType(key));
  // };

  const handleDashboardChange = React.useCallback((id: string) => {
    dispatch(setSelectedDashboardId(id));
  }, [dispatch]);

  const allDashboards = defaultDashboard ? [defaultDashboard, ...dashboards] : [...dashboards];

  const tabOptions = React.useMemo(() => allDashboards.filter((item: any) => item?.showAsTab).map((item: any) => ({
    label: item?.name,
    value: item?.id,
  })), [allDashboards]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`admin-header-warp ${i18n.language === 'ar' ? 'rtl' : ''}`}>
      <div className="admin-header-content">
        {dashboard && (
          <TabToggle
            tabs={tabOptions}
            defaultTab={selectedDashboardId}
            onChange={handleDashboardChange}
            isLabelValue
          />
        )}
        <div className="admin-header-center">
          <div className="header-image">
            {/* <img src={brandImage.logo} alt="logo" /> */}
            <h3>{title}</h3>
            {count !== undefined && count !== null && (
              <div className="title-count-badge">
                {icon || <TrendUp />}
                <span>{count}</span>
              </div>
            )}
          </div>
        </div>
        <div className="admin-header-right">
          <div className="item">
            {notification && (
              <div
                className="notification"
                onClick={() => setDropdownNotification(true)}
                role="presentation">
                <Notification />
                <div className="tag tag-danger">3</div>
              </div>
            )}

            {dropdownNotification && (
              <div className="dropdown-notification" ref={reference}>
                <div className="dropdown-layout">asfdas</div>
              </div>
            )}
          </div>
          {/* <LanguageSelector /> */}
          <div className="item">
            <div className="profile">
              <div className="item profile-image">
                <img src={profile} alt="profile" />
              </div>
              <div className="item profile-details">
                <div className="profile-name">{t('superAdmin')}</div>
                <div className="profile-dropdown-icon">
                  {/* <Downarrow /> */}
                </div>
              </div>
              {dropdownOpen && (
                <div className="dropdown-content" ref={reference}>
                  <div className="dropdown-layout">
                    {headerList1.filter((value) => value.allow === true).length > 0 && (
                      <div className="dropdown-header">
                        {headerList1.map(
                          (value: any) =>
                            value.allow && (
                              <div
                                className={`header-item ${value.active && 'open'}`}
                                onClick={() => value.function(value.key)}
                                role="presentation">
                                <value.icon />
                              </div>
                            ),
                        )}
                      </div>
                    )}

                    <div className="dropdown-body">
                      <div className="body-list">
                        {headerList2.map(
                          (value) =>
                            value.allow && (
                              <div className="item" onClick={value.function} role="presentation">
                                <div className={value.addClass}>{value.label}</div>
                                {/* <div className="list-icon"><Downarrow /></div> */}
                              </div>
                            ),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
